import { Shape } from './Shape.js';
import { fabric } from 'fabric';
import { ShapeAction } from './ShapeFactory.js';
//const fabric = window.fabric;
var defaultProps = {
    fontFamily: 'Open Sans',
    fontSize: 30,
    width: 200,
    stroke: 'red',
    fill: 'red',
    textAlign: 'left',
};

const PLACEHOLDER_TEXT  = 'Add text...';

class TextBox extends Shape {
    constructor(props) {
        super(props);
        this.textBox = null;
        this.doubleClicked = props.doubleClicked;
    }
    draw(props) {
        //working while snapsot
        this.newProps = {
            ...defaultProps,
            ...props
        };

        //Forcing both color to be similar

        props.stroke = props.fill;
        this.newProps.stroke = this.newProps.fill;

        if (props.action !== ShapeAction.START) {         
            let canvasObject = new fabric.Textbox('', props);
            canvasObject.setControlsVisibility({
                mt: false, // middle top disable
                mb: false, // midle bottom           
            });
            this.attachDoubleClicked(canvasObject, this.doubleClicked);
            super.draw(canvasObject);
            return;
        }
        const events = {
            onCanvasMouseDown: this.onMouseDown.bind(this),
            onCanvasMouseUp: this.onMouseUp.bind(this)
        };

        this.drawingCanvas.registerEvents(events);
    }
    onMouseDown(points) {
        var _this = this;
        const [x, y] = points;
        this.newProps = { ...this.newProps, left: x, top: y };        
        this.textBox = new fabric.Textbox(PLACEHOLDER_TEXT, this.newProps);
        this.textBox.uuid = this.newProps.uuid;
        this.textBox.uuid_parent = this.newProps.uuid_parent;
        this.attachDoubleClicked(this.textBox, this.doubleClicked);
        
        this.textBox.on('changed', this.onTextChanged.bind(this));
        this.textBox.on('editing:entered', this.onEditingEntered);

        this.textBox.set('showPlaceholder', true);

        this.textBox.setControlsVisibility({
            mt: false, // middle top disable
            mb: false, // midle bottom           
        });
        this.drawingCanvas.addAsActiveShape(this.textBox);
        this.textBox.enterEditing();        
    }

    onMouseUp() {
        this.drawingCanvas.removeEvents();
        this.newProps.action = ShapeAction.ADD;
        super.toFebricObject(this.textBox);
        if (this.onDrawCompleted) {
            this.onDrawCompleted({
                showPlaceholder : this.textBox.showPlaceholder,
                ...this.newProps,
                ...this.textBox.toObject()
            });
        }
    }


    attachDoubleClicked(canvasObj, doubleClicked){
        canvasObj.on('mousedblclick', function(e) {
            if (doubleClicked) {
                doubleClicked(e.target);
            }
        })
    }


    attachOnChanged(canvasObj, some){
        canvasObj.on('mousedblclick', function(e) {
            if (some) {
                some(e.target);
            }
        })
    }

    onTextChanged() {        
        let obj = this.textBox;
        if (obj.text === '') {
            this.createPlaceholder(obj);
        }
        else if (obj.showPlaceholder === true) {
            this.removePlaceholder(obj);
        }
    }

    removePlaceholder(obj) {
        if (obj.text !== PLACEHOLDER_TEXT) {                    
            this.changeText(obj, obj.text[0]);
            obj._updateTextarea();
            obj.set('opacity', 1);
            obj.set('showPlaceholder', false); 
            obj.setCoords();
            this.drawingCanvas.renderAll();
        }
    }

    changeText(obj, newText) {
        obj.set('text', newText);
        obj.hiddenTextarea.value = newText;
    }

    createPlaceholder(obj) {
        obj.text = PLACEHOLDER_TEXT;
        obj.set('opacity', 0.3);
        obj.set('showPlaceholder', true); 
        obj.setCoords();
        this.drawingCanvas.renderAll();
    }

    onEditingEntered() {       
        var obj = this;        
        if(obj.showPlaceholder === true)
        {            
            obj.setSelectionStart(0);
            obj.setSelectionEnd(0);
            obj.set('opacity', 0.3);
            this.canvas.renderAll();
        }
    }

}

export { TextBox };
